import { jsx as _jsx } from "react/jsx-runtime";
import { Briefcase, Contact, FileText, MonitorCog, UserCircle, UserRoundPen, Waypoints } from "lucide-react";
import { GrGroup } from "react-icons/gr";
import { BuildingUser } from "../components/icons/BuildingUser";
/**
 * Canonical glyph for a SoftwareSystem entity — a monitor with a gear.
 *
 * Single source of truth shared by the frontend entity-icon registry
 * (`ENTITY_ICONS.system`) and every ui-package system surface (system card,
 * swimlane/end nodes, step detail). packages/ui can't import the frontend
 * registry, so the canonical value lives here and the frontend registry
 * re-points at it — the system icon can't drift between screens.
 */ export const SYSTEM_ICON = MonitorCog;
/**
 * Canonical glyph for the "successor / Bearbeiter" concept — who takes over the
 * next step (or, in assignee mode, does the current one).
 *
 * Single source of truth shared by the frontend registry (`ENTITY_ICONS.successor`)
 * and every ui-package successor surface (step-detail successors section). Used
 * for the SuccessorCard header (both Bearbeiter and Nachfolger variants) and the
 * successor picker dialog header so the marker never drifts between screens.
 */ export const SUCCESSOR_ICON = UserRoundPen;
/**
 * Wrapper function to apply stroke width adjustment class to react-icons.
 * This ensures react-icons render with strokeWidth={1.5} to match Lucide icons.
 *
 * @param Icon - The react-icon component to wrap
 * @returns A component that applies the CSS class for stroke adjustment
 */ const createReactIconWithStroke = (Icon)=>{
    const WrappedIcon = ({ className, ...props })=>/*#__PURE__*/ _jsx(Icon, {
            ...props,
            className: `react-icon-stroke-adjust ${className || ""}`
        });
    const iconName = Icon.displayName || Icon.name || "Icon";
    WrappedIcon.displayName = `StrokeAdjusted(${iconName})`;
    return WrappedIcon;
};
/**
 * Canonical per-kind entity glyphs, mirroring SYSTEM_ICON's rationale:
 * packages/ui cannot import the frontend registry, so the canonical values
 * live here and both the frontend registry and apps re-point at them — the
 * per-kind icons can't drift between screens.
 */ export const ENTITY_KIND_ICONS = {
    role: Briefcase,
    department: BuildingUser,
    team: createReactIconWithStroke(GrGroup),
    person: UserCircle,
    externalContact: Contact,
    artifact: FileText,
    system: SYSTEM_ICON,
    process: Waypoints
};

//# sourceMappingURL=entity-icons.js.map